var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "" } },
    [
      _vm.loadingComponent
        ? _c("loader", { attrs: { loading: _vm.loadingComponent } })
        : _c(
            "md-theme",
            { attrs: { "md-name": "blue" } },
            [
              _c("breadcrumbs", {
                attrs: { section: "Playlists", nav: _vm.nav }
              }),
              _c(
                "md-layout",
                { staticClass: "form-wrapper", attrs: { "md-gutter": 16 } },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("metadata-form", {
                            attrs: {
                              entity: _vm.playlist,
                              "form-submitted": _vm.formSubmitted,
                              validations: _vm.$v.playlist,
                              title: ""
                            }
                          }),
                          _vm.editMode
                            ? _c("playlist-content-table", {
                                staticClass: "playlist-content-table",
                                attrs: {
                                  videos: _vm.playlist.items,
                                  label: "Playlist content",
                                  deletingItem: _vm.deletingItem
                                },
                                on: { removeItem: _vm.onItemRemoved }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-align": "center" } },
                    [
                      _c("stitch-loader", {
                        attrs: { loading: _vm.creatingOrUpdating, size: 40 }
                      }),
                      _c(
                        "md-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.creatingOrUpdating,
                              expression: "!creatingOrUpdating"
                            }
                          ],
                          staticClass: "md-raised md-primary",
                          attrs: {
                            id: "submit-btn",
                            disabled: _vm.$v.$pending,
                            "md-theme": "blue"
                          },
                          on: { click: _vm.onFormSubmit }
                        },
                        [_vm._v(_vm._s(_vm.editMode ? "Update" : "Create"))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8cd1982", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8cd1982","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/playlist/PlaylistForm.vue
// module id = 856
// module chunks = 0